import { render } from "./TenanciesEdit.vue?vue&type=template&id=09417c4c&scoped=true&ts=true"
import script from "./TenanciesEdit.vue?vue&type=script&lang=ts"
export * from "./TenanciesEdit.vue?vue&type=script&lang=ts"

import "./TenanciesEdit.vue?vue&type=style&index=0&id=09417c4c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09417c4c"]])

export default __exports__